import { handleRequest } from "..";
import { httpAuthorized } from "@/main";

// 上传 CCS xlsx 文件（上传后自动解析）
export const uploadCcsFileApi = async (
  file: File,
  protocol: string,
  options?: { shipId?: string; version?: number; author?: string }
): Promise<{ filePath: string; parsedData: Record<string, any> } | null> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("protocol", protocol);
  if (options?.shipId) formData.append("shipId", options.shipId);
  if (options?.version) formData.append("version", String(options.version));
  if (options?.author) formData.append("author", options.author);
  return handleRequest<{ filePath: string; parsedData: Record<string, any> }>(
    httpAuthorized.post("/ccsReport/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
    (data) => data.data.result
  );
};

// 仅上传 CCS xlsx 文件（不解析），返回 filePath
export const uploadCcsFileRawApi = async (
  file: File,
  protocol: string
): Promise<string | null> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("protocol", protocol);
  return handleRequest<string>(
    httpAuthorized.post("/ccsReport/upload/raw", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
    (data) => data.data.result
  );
};

// 解析 CCS xlsx 文件
export const parseCcsFileApi = async (params: {
  filePath: string;
  protocol: string;
  shipId: string;
  version: number;
  author: string;
}): Promise<Record<string, any> | null> => {
  return handleRequest<Record<string, any>>(
    httpAuthorized.post("/ccsReport/parse", params),
    (data) => data.data.result
  );
};

// 使用在线编辑规则解析动态协议
export const parseDynamicOnlineApi = async (params: {
  sheets: TemplateSheet[];
  shipId: string;
  version: number;
  author: string;
}): Promise<Record<string, any> | null> => {
  return handleRequest<Record<string, any>>(
    httpAuthorized.post("/ccsReport/parse/online", params),
    (data) => data.data.result
  );
};

// 下载动态协议模板 xlsx（POST 静态协议 JSON，动态生成列数和值来源）
export const downloadDynamicTemplateApi = async (
  staticData?: Record<string, any>
): Promise<Blob | null> => {
  try {
    const response = await httpAuthorized.post(
      "/ccsReport/dynamic/template",
      staticData ?? {},
      { responseType: "blob" }
    );
    return response.data as Blob;
  } catch (err) {
    return null;
  }
};

// 模板 sheet 行结构（与后端 generateTemplateJson 对应）
export interface TemplateSheetRow {
  key: string;
  name: string;
  type: string;
  sources: string[];
}
export interface TemplateSheet {
  name: string;
  sourceColumns: number;
  codes: string[] | null;
  rows: TemplateSheetRow[];
}

// 获取动态协议模板 JSON（POST 静态协议 JSON，动态生成列数和值来源）
export const fetchDynamicTemplateJsonApi = async (
  staticData?: Record<string, any>
): Promise<TemplateSheet[] | null> => {
  return handleRequest<TemplateSheet[]>(
    httpAuthorized.post("/ccsReport/dynamic/template/json", staticData ?? {}),
    (data) => data.data.result
  );
};

// 发送 CCS 报送 JSON
export const sendCcsReportApi = async (params: {
  packageData: Record<string, any>;
  shipId: string;
}): Promise<boolean | null> => {
  return handleRequest<boolean>(
    httpAuthorized.post("/ccsReport/send", params),
    (data) => data.data.result
  );
};
